import { CarouselBanners } from "@/Slice"
import { ListerDocument } from "@/lib/prismicio/types.generated"
import { PropsWithChildren } from "react"

export const SliceRender = ({ slices }: PropsWithChildren<{ slices: ListerDocument["data"]["body"] }>) => (
    <div>
        {[...slices]
            .filter((slice) => !slice.primary.is_hide_module)
            .map((slice, index) => (
                <Slice key={index} slice={slice} lcp={index < 2} />
            ))}
    </div>
)
export const Slice = ({
    slice,
    lcp,
}: PropsWithChildren<{ slice: ListerDocument["data"]["body"][number]; lcp: boolean }>) => {
    switch (slice.slice_type) {
        case "carousel_banners": {
            return <CarouselBanners slice={slice} lcp={lcp} />
        }

        default: {
            return <></>
        }
    }
}
